import { UserState } from "./interface";

export const state: UserState = {
  UserById: {},
  UserAllId: [],
  logged_user: undefined
};
